import type { EventImage } from "@/types";

export interface ImageOverlays {
  added: EventImage[];
  deletedIds: Set<string>;
  coverId: string | null;
}

export const emptyOverlays: ImageOverlays = {
  added: [],
  deletedIds: new Set(),
  coverId: null,
};

export function mergeImageOverlays(
  fetched: EventImage[] | undefined,
  overlays: ImageOverlays,
): EventImage[] {
  if (!fetched) return [];
  const fetchedIds = new Set(fetched.map((img) => img.id));
  const fetchedCoverId = fetched.find((img) => img.isCover)?.id ?? null;
  const extras = overlays.added.filter((img) => !fetchedIds.has(img.id));
  const merged = [...fetched, ...extras].filter((img) => !overlays.deletedIds.has(img.id));
  if (overlays.coverId === null || overlays.coverId === fetchedCoverId) return merged;
  return merged.map((img) => ({ ...img, isCover: img.id === overlays.coverId }));
}
